export default __webpack_public_path__ + "static/media/PuntosDeMuestreoCEA.2772054e.kml";